// The organisation's imprint, terms and privacy links, at the foot of every patient-facing page
// (questionnaire, document upload, signing, informed consent, SEPA). Links come from the
// organisation's settings (Super Admin → Organisation). Only links that are set appear: no link is
// better than another company's imprint.
import { useTranslation } from 'react-i18next'
import { useTenant } from '../context/TenantContext'

const isWebUrl = (url: string | null | undefined): url is string => !!url && /^https?:\/\//i.test(url.trim())

export function LegalFooter() {
  const { t } = useTranslation()
  const { tenant } = useTenant()
  const links = [
    { key: 'imprint', url: tenant?.imprintUrl, label: t('common.impressum') },
    { key: 'terms', url: tenant?.termsUrl, label: t('common.agb') },
    { key: 'privacy', url: tenant?.privacyUrl, label: t('common.datenschutz') },
  ].filter((l): l is { key: string; url: string; label: string } => isWebUrl(l.url))
  if (links.length === 0) return null
  return (
    <footer className="py-4 px-4 text-center text-small text-muted-foreground" data-testid="legal-footer">
      {links.map((l, i) => (
        <span key={l.key}>
          {i > 0 && <span className="mx-2" aria-hidden="true">|</span>}
          <a href={l.url.trim()} target="_blank" rel="noopener noreferrer" className="hover:underline" data-link={l.key}>{l.label}</a>
        </span>
      ))}
    </footer>
  )
}
